<ng-container *transloco="let t; read: 'time-entries'">
    <ng-container *ngIf="vm$ | async as vm">
    <h3 class="pbm">{{ viewMode === 'entry' ? t('entryReports') : viewMode === 'day' ? t('dayReports') : t('weekReports') }}</h3>
    <form
    [formGroup]="filterForm"
    (ngSubmit)="onSubmitFilter()"
    class="grid col2 mbm"
  >
    <div class="span3 flex flexDirRow alignCenter gaps">
      <kendo-daterange>
        <kendo-floatinglabel text="Start" class="mrs">
          <kendo-dateinput
            formControlName="dateRangeStart"
            kendoDateRangeStartInput
          ></kendo-dateinput>
        </kendo-floatinglabel>
        <kendo-floatinglabel text="End">
          <kendo-dateinput
            formControlName="dateRangeEnd"
            kendoDateRangeEndInput
          ></kendo-dateinput>
        </kendo-floatinglabel>
        <kendo-daterange-popup [animate]="false"></kendo-daterange-popup>
      </kendo-daterange>

      <kendo-formfield *ngIf="viewMode !== 'entry'">
        <kendo-label [text]="viewMode === 'day' ? t('showOnlyConfirmable.labelDay') : t('showOnlyConfirmable.label')"></kendo-label>
        <kendo-switch
          formControlName="showOnlyConfirmable"
          [onLabel]="''"
          [offLabel]="''"
        ></kendo-switch>
      </kendo-formfield>
    </div>

    <div>
      <button
        [disabled]="filterForm.invalid"
        type="submit"
        kendoButton
        fillMode="solid"
        size="medium"
        rounded="medium"
        themeColor="primary"
        class="mbs mrs"
        [loadingIndication]="searchLoadingUrl"
      >
        Suchen
      </button>

      <button
        [disabled]="filterForm.invalid"
        *ngIf="filterForm.touched"
        kendoButton
        fillMode="solid"
        size="medium"
        rounded="medium"
        themeColor="secondary"
        (click)="onResetFilter()"
        class="mbs"
        [loadingIndication]="searchLoadingUrl"
      >
        Zürucksetzen
      </button>

      <!-- One's own day reports, in the week and the day view. Only for an applied date range -
           the same values onExport() sends - since an unbounded export can grow huge. -->
      <button
        *ngIf="viewMode !== 'entry' && canExport && daySearchRequest.employeeId && daySearchRequest.startDate && daySearchRequest.endDate"
        type="button"
        (click)="onExport()"
        kendoButton
        fillMode="solid"
        size="medium"
        rounded="medium"
        themeColor="primary"
        class="mbs mls"
        loadingIndication="TimeEntry/exportDayReportingObjects"
      >
        {{ t('excelExportBtn') }}
      </button>
    </div>
  </form>
    <div class="mbm align-right">
      <kendo-buttongroup [selection]="'single'">
        <button
          kendoButton
          [selected]="viewMode === 'entry'"
          [toggleable]="true"
          (click)="onViewModeChange('entry')"
        >
          {{ t('entryReports') }}
        </button>
        <button
          kendoButton
          [selected]="viewMode === 'week'"
          [toggleable]="true"
          (click)="onViewModeChange('week')"
        >
          {{ t('weekReports') }}
        </button>
        <button
          kendoButton
          [selected]="viewMode === 'day'"
          [toggleable]="true"
          (click)="onViewModeChange('day')"
        >
          {{ t('dayReports') }}
        </button>
      </kendo-buttongroup>
    </div>

    <app-week-reporting-grid
    *ngIf="viewMode === 'week'"
    [weekReportingObjects]="weekReportingObjectsGridData"
    [searchRequest]="searchRequest"
    [showtimeSupplementTimeChanges]="vm.tenantSettings?.hasTimeSupplements"
    [showOvertime]="vm.tenantSettings?.hasOvertime"
    [showDayFlexPreWorkChanges]="true"
    [sortable]="true"
    [totalWorkTime]="weekTotalWorkTime"
    [totalFlexTime]="weekTotalFlexTime"
    [totalPreWorkTime]="weekTotalPreWorkTime"
    [grandWorkTime]="weekGrandWorkTime"
    [grandFlexTime]="weekGrandFlexTime"
    [grandPreWorkTime]="weekGrandPreWorkTime"
    (onUpdateGrid)="updateList()"
  >
  </app-week-reporting-grid>

  <app-day-reporting-grid
    *ngIf="viewMode === 'day'"
    [dayReportingObjects]="dayReportingObjectsGridData"
    [isAdminView]="false"
    [showSignAction]="true"
    [isEditable]="false"
    [showFlexPreWorkChanges]="true"
    [sortable]="true"
    [pageable]="true"
    [searchRequest]="daySearchRequest"
    [total]="dayTotalCount"
    [totalWorkTime]="dayTotalWorkTime"
    [totalFlexTimeChange]="dayTotalFlexTime"
    [preWorkTimeChange]="dayTotalPreWorkTime"
    [grandWorkTime]="dayGrandWorkTime"
    [grandFlexTime]="dayGrandFlexTime"
    [grandPreWorkTime]="dayGrandPreWorkTime"
    (onUpdateGrid)="updateList()"
  >
  </app-day-reporting-grid>

  <!-- One's own entries, editable with the Self rights. New entries are always for oneself. -->
  <app-time-entry-grid
    *ngIf="viewMode === 'entry'"
    [timeEntries]="timeEntriesGridData"
    [searchRequest]="entrySearchRequest"
    [isAdminView]="canWriteOwnEntries"
    [ownEntriesOnly]="true"
    [totalTime]="entryTotalTime"
    [grandTotalTime]="entryGrandTotalTime"
    (onUpdateGrid)="updateList()"
  ></app-time-entry-grid>
</ng-container>
</ng-container>